import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {AssessmentModel} from "../../../../interfaces/AssessmentModel";
import {Observable} from "rxjs";
import {Employee} from "../../../../interfaces/Employee";
import {EmployeeService} from "../../../../services/employee.service";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {CounselingService} from "../../counseling.service";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {DatePipe} from "@angular/common";
import {ViewGroupSessionComponent} from "../../components/view-group-session/view-group-session.component";
import {MatDialog} from "@angular/material/dialog";
import {FullChild} from "../../../../interfaces/FullChild";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {Subject} from "rxjs/internal/Subject";
import {takeUntil} from "rxjs/internal/operators/takeUntil";

@Component({
  selector: 'app-counselling-group-session',
  templateUrl: './counselling-group-session.component.html',
  styleUrls: ['./counselling-group-session.component.scss']
})
export class CounsellingGroupSessionComponent implements OnInit,OnDestroy {

  displayedColumns: string[] = [ 'createdAt','childrenNames', 'centres', 'topicsCovered','date','Action'];
  particiapant:string=''
  types=["Male","Female","Family","Child"]

  mAllData:any[]=[]
  mFilteredData:any[]=[]
  data:any

  selectedCentre?:string|null=null
  dataSource!: MatTableDataSource<any>;
  startDate?: Date | null
  endDate?: Date | null
  selectedCentreCode?: string | null
  counselorName=''
  employee: Observable<Employee[]>
  _centres$: Observable<Centre[]>
  sessionTopics=[]
  children$?: Observable<FullChild[]>
  startTime: any
  endTime: any
  targetGroup='Male'
  centres:any[]=[]
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  destroyed$= new Subject()
  constructor(
    private centreService: CentreService,
    private employeeService: EmployeeService,
    private  counselingService: CounselingService,
    private datePipe: DatePipe,
    private  readonly matDialog:MatDialog,

  ) {
    this.employee = this.employeeService.getCounsellersFromUsers()
    this.dataSource = new MatTableDataSource<AssessmentModel>()
    this._centres$ = this.centreService.getAllCentres()
        this._centres$.pipe(takeUntil(this.destroyed$)).subscribe(c=>{
          c.forEach(centre=>{

            this.centres.push({centreName:centre.centreName,centreCode:centre.centreCode})
          })
    })
  }

  ngOnInit(): void {
    this.counselingService.fetchGroupSessions().pipe(takeUntil(this.destroyed$)).subscribe(res=>{
      this.mAllData = res
      this.dataSource.data = this.mAllData
      this.dataSource.sort=this.sort
      this.dataSource.paginator =this.paginator
    })
  }

  getchildNames(children: any[]):string {
    let str=''
    children.forEach((it,index)=>{
      if(children.length-1==index)  str += it.childName+' '
      else  str += it.childName+', '
    })
    return str
  }

  getCenterNames(centres: any) :string{
    let str=''
    centres.forEach((it: { centreName: string; },index:number)=>{
      if(centres.length-1 ==index)  str += it.centreName+' '
      else  str += it.centreName+', '
    })
    return str
  }
  getTopicsCovered(centres:any[]):string{
    let str=''
    centres.forEach(it=>{
      str += it+' '
    })
    return str
  }

  getDate(date: Date):any {
    let d = (date as unknown as Timestamp).toDate()
    return this.datePipe.transform(d, 'dd-MMM-yyyy')
  }

  viewDialog(element:any) {
    this.matDialog.open(ViewGroupSessionComponent,{data:element,
      width:'800%',
      height:'90%'})
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();



  }

  Search() {
    // console.log(this.startDate!.getTime())
    // console.log(this.endDate!.getTime())
    this.mFilteredData = this.mAllData
    console.log('AT START',this.mFilteredData)
    // if centre selected
// 100
    if(this.selectedCentre!=null){
      console.log('into SelectedCentre')
      this.mFilteredData = this.mFilteredData.filter((x)=> (x.centres[0]==this.selectedCentre))
      console.log(this.mFilteredData)
    }
    if(this.startDate!=null){
      console.log('into startDate')

      this.mFilteredData =  this.mFilteredData.filter((x)=> x.createdAt>=this.startDate!.getTime())
// 50
    }
    if(this.endDate!=null){
      console.log('into End Date')


      // 50
      this.mFilteredData =  this.mFilteredData.filter((x)=> x.createdAt<=this.endDate!.getTime())

    }

    if(this.particiapant!=null && this.particiapant!=''){
      console.log('into Participant')

      this.mFilteredData = this.mFilteredData.filter((x)=> x.participants ==this.particiapant)
    }

    if(this.counselorName!=null && this.counselorName!=''){
      console.log('into counseller name')

      this.mFilteredData = this.mFilteredData.filter((x)=> x.personConductingTest ==this.counselorName)

    }
if(this.sessionTopics!=null && this.sessionTopics.length>=1){
  console.log('into session Topics',this.sessionTopics)
      this.mFilteredData = this.mFilteredData.filter((x)=> x.topicsCovered==this.sessionTopics)
  console.log(this.mFilteredData)
    }



    this.dataSource.data=this.mFilteredData
  }
  clearAll() {
    this.startDate = null
    this.endDate =null
    this.counselorName =''
    this.selectedCentre = null
    this.sessionTopics =[]
    this.dataSource.data=this.mAllData
  }

  ngOnDestroy(): void {
    this.destroyed$.next(null)
    this.destroyed$.complete()
  }


}
